const actions = {
  
  DONATIONS_READ_BEGIN: 'DONATIONS_READ_BEGIN',
  DONATIONS_READ_SUCCESS: 'DONATIONS_READ_SUCCESS',
  DONATIONS_READ_ERR: 'DONATIONS_READ_ERR',

  DONATIONS_DELETE_BEGIN: 'DONATIONS_DELETE_BEGIN',
  DONATIONS_DELETE_SUCCESS: 'DONATIONS_DELETE_SUCCESS',
  DONATIONS_DELETE_ERR: 'DONATIONS_DELETE_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.DONATIONS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.DONATIONS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.DONATIONS_READ_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.DONATIONS_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.DONATIONS_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.DONATIONS_DELETE_ERR,
      err,
    };
  }

};

export default actions;
